import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';


import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';


import Breadcrumbs from '@mui/material/Breadcrumbs';


import { green } from '@mui/material/colors';

const styles = theme => ({

    root: {
        margin: 0,
        padding: 0
    },

    formControl: {
        width: '100%'
    },

    formControl2: {
        paddingLeft: '16px'
    },

    motifResolutionCompteContainer: {
        display: 'flex',
        alignItems: 'baseline'
    },

    motifResolutionCompteItem: {
        alignSelf: 'baseline'
    },
    

    removeIcon: {
        color: 'red'
    },
    addIcon: {
        margin: '16px',
        color: 'green'
    },

    buttonControl: {
        margin: '8px 0px 8px 16px'
    },

    buttonControlMotifsResolutionSecurite: {
        margin: '8px 16px 8px 16px'
    },

    chip: {
        margin: '8px 8px 8px 0px'
    },
    listElement: {
        margin: 10,
        padding: '4px 8px 4px 8px'
    },

    bold: {
        fontWeight: theme.typography.fontWeightMedium
    },

    container: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column'
    },

    containerPilotes: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row'
    },

    containerMotifsResolutionSecurite: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        padding: 8
    },

    containerDrop: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        minHeight: '100px'
    },

    containerLeft: {
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        marginRight: theme.spacing(1)
    },


    actionContainer: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row-reverse',
        marginBottom: theme.spacing(3)
    },

    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },

    table: {
        minWidth: 700
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },


    link: theme.style.link,
    

    guTransit: {
        color: green[500]
    },

    guMirror: {
        color: green[500]
    },



    button: {
        margin: theme.spacing(1)
    },
    leftIcon: {
        marginRight: theme.spacing(1)
    },
    rightIcon: {
        marginLeft: theme.spacing(1)
    },
    iconSmall: {
        fontSize: 20
    }
});



class AdministrationMotifResolution extends React.Component {
             

    render() {
        let { classes, selectedMotifResolution, onChange, onClickSave, isPatching, sauvegardable } = this.props;

        
        return (
            <React.Fragment>
                

                {selectedMotifResolution && (
                    <div className={classes.root}>

                        <Helmet>
                            <title>{`Motif de résolution : ${selectedMotifResolution.code}`}</title>
                        </Helmet>

                        <Typography gutterBottom variant="h5">
                            Édition du motif de résolution : {selectedMotifResolution.code}
                        </Typography>


                        <Breadcrumbs separator="›" arial-label="breadcrumb">
                            <Link to={`/administration/motifsResolution/`} className={classes.link}>
                                <Typography variant="button">
                                    Motifs de résolution
                                </Typography>
                            </Link>

                            <Typography color="textPrimary">{selectedMotifResolution.code}</Typography>
                        </Breadcrumbs>


                        <Paper className={classes.paper}>

                            <Typography gutterBottom variant="h6">
                                Paramètres
                            </Typography>

                            <TextField className={classes.formControl}
                                id="code"
                                name="code"
                                label="Code"
                                placeholder="Code"
                                required
                                margin="normal"
                                value={selectedMotifResolution.code}
                                disabled
                            />

                            <TextField className={classes.formControl}
                                id="libelle"
                                name="libelle"
                                label="Libellé"
                                placeholder="Libellé"
                                required
                                margin="normal"
                                value={selectedMotifResolution.libelle}
                                onChange={onChange}
                            />
                                                                                                          

                        </Paper>


                        <div className={classes.actionContainer} >

                            <Link to="/administration/motifsResolution">
                                <Button
                                    className={classes.buttonControl}
                                    disabled={!sauvegardable || isPatching}
                                    onClick={onClickSave}
                                    variant="contained"
                                    color="secondary"
                                >
                                    Enregistrer
                                    {isPatching === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                                </Button>
                            </Link>
                            <Link to="/administration/motifsResolution">
                                <Button className={classes.buttonControl} color="primary" >
                                    Annuler
                                </Button>
                            </Link>
                        </div>



                    </div>
                )}


            </React.Fragment>


        );
    }
}

AdministrationMotifResolution.propTypes = {
    classes: PropTypes.object.isRequired,
    onClickCancel: PropTypes.func.isRequired,
    onClickSave: PropTypes.func.isRequired,    

    onChange: PropTypes.func.isRequired,

    sauvegardable: PropTypes.bool.isRequired,
    isPatching: PropTypes.bool.isRequired,
    selectedMotifResolution: PropTypes.object
};

export default withStyles(styles)(AdministrationMotifResolution);